// @ts-nocheck
/// <reference path="../../../microsoftmaps/microsoft.maps.all.d.ts" />
import $ from 'jquery';
import { CurrentStatus } from './../components/routecomponents/DryDetails';
import bingcenterSelected from '../images/bingcenterSelected_icon.png';
import { initialize, whenLoaded } from "bing-maps-loader";
//import '../actions/bingmaps.api';
//require('../actions/bingmaps.api.js');
var Config: any = require('../Config.json');
var reeferDetailsMap = null;
var geoZonesLayer = null;
var detailsLayer = null;
class DetailsMap {
    static InitDetailsMap(mapId: any) {
        whenLoaded.then(() => {
            reeferDetailsMap = new Microsoft.Maps.Map("#" + mapId,
                {
                    credentials: Config.BingMapsKey,
                    mapTypeId: Microsoft.Maps.MapTypeId.road,
                    zoom: 10,
                    showMapTypeSelector: false,
                    showZoomButtons: false,
                    showLocateMeButton: false
                });
            Microsoft.Maps.Events.addHandler(reeferDetailsMap, 'maptypechanged', function (args) {
                mapTypeChanged(args);
            });
        });
        
    }
    
    static LoadDetailsMap(latitude: any, longitude: any) {
        if(detailsLayer != null)
            detailsLayer.clear();
        if (latitude != null && longitude != null) {
            detailsLayer = new Microsoft.Maps.Layer();
            reeferDetailsMap.setView({
                center: new Microsoft.Maps.Location(latitude, longitude),
                zoom: 10
            });
            var center = reeferDetailsMap.getCenter();
            var pushpinImage = bingcenterSelected;
            var pushpinOptions = { icon: pushpinImage, height: 31, width: 20, anchor: new Microsoft.Maps.Point(11, 8) };
            var pushpin = new Microsoft.Maps.Pushpin(center, pushpinOptions);
            detailsLayer.add(pushpin);
            reeferDetailsMap.layers.insert(detailsLayer);
        }
        else {
            reeferDetailsMap.entities.clear();
        }
    }  
    
    static BindGeoZonesLayer(latitude: any, longitude: any, positionAccuracy: any) {   
        if(geoZonesLayer != null)
            geoZonesLayer.clear();
        if(latitude !=null && longitude !=null && (positionAccuracy !=null && positionAccuracy > 0)) {
            geoZonesLayer = new Microsoft.Maps.Layer();
            geoZonesLayer.setZIndex(10400);
            var loc = new Microsoft.Maps.Location(latitude, longitude);
            Microsoft.Maps.loadModule('Microsoft.Maps.SpatialMath', function () {
                var paths = Microsoft.Maps.SpatialMath.getRegularPolygon(loc, positionAccuracy, 36, Microsoft.Maps.SpatialMath.DistanceUnits.Meters);
                var polygon = new Microsoft.Maps.Polygon(paths, null);
                geoZonesLayer.add(polygon);            
                reeferDetailsMap.layers.insert(geoZonesLayer);
            });
        }
    } 
    static DisposeGeozonesLayer() {
        if (geoZonesLayer != null)
            geoZonesLayer.clear();
    } 
}
function mapTypeChanged(params) {
    var mapType = reeferDetailsMap.getImageryId();
    if (mapType == "Aerial") {        
        $("#geoZones").removeClass('map-Geofence');
        $("#geoZones").addClass('mapGeofenceAerial');
        CurrentStatus.UpdateFenceImage('A');
    }
    else {        
        $("#geoZones").removeClass('mapGeofenceAerial');
        $("#geoZones").addClass('map-Geofence');  
        CurrentStatus.UpdateFenceImage('R');
    }
}

export default DetailsMap;